/* eslint-disable import/extensions */
/* eslint-disable max-lines-per-function */
/* eslint-disable import/prefer-default-export */
import Swiper from "swiper";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/scss";
import { track } from "jiffy-analytics";
import "./slider.scss";

const SLIDER_SPEED = 1000;

const trackCarouselNavigation = (direction, page) => {
  const eventData = {
    direction,
    page
  };
  track("review_carousel_navigated", eventData);
};

export function initSlider({
  containerSelector,
  spaceBetween,
  trackingPage = null,
  loop = true,
  speed = SLIDER_SPEED,
  delay = 1500,
  delayTouchDevices = speed,
  autoplay = {
    delay,
    disableOnInteraction: false,
    pauseOnMouseEnter: true
  }
}) {
  const $container = document.querySelector(containerSelector);

  if (!$container) {
    return;
  }

  let isDragging = false;
  let resumeTimeout = null;

  const swiper = new Swiper($container, {
    modules: [Autoplay, Navigation],
    loop,
    autoplay,
    speed,
    slidesPerView: 1.3,
    loopPreventsSliding: false,
    spaceBetween,
    centeredSlides: true,
    breakpoints: {
      768: {
        slidesPerView: 2.3
      },
      992: {
        slidesPerView: 3,
        centeredSlides: false
      }
    },
    navigation: {
      prevEl: `${containerSelector} .js-jiffymade-landing-ui-slider-button-prev`,
      nextEl: `${containerSelector} .js-jiffymade-landing-ui-slider-button-next`
    },

    /* -------- Swiper hooks ---------- */
    on: {
      navigationNext: () => {
        swiper.navigation.nextEl.disabled = true;
        trackCarouselNavigation("right", trackingPage);
      },
      slideChangeTransitionEnd() {
        swiper.navigation.nextEl.disabled = false;
        swiper.navigation.prevEl.disabled = false;
      },
      navigationPrev: () => {
        swiper.navigation.prevEl.disabled = true;
        trackCarouselNavigation("left", trackingPage);
      },
      /* drag‑and‑drop */
      sliderFirstMove() {
        isDragging = true;
      },
      touchEnd: () => {
        if (resumeTimeout) clearTimeout(resumeTimeout);

        if (isDragging && swiper.swipeDirection) {
          const direction = swiper.swipeDirection === "next" ? "right" : "left";
          trackCarouselNavigation(direction, trackingPage);
        }
        isDragging = false;

        swiper.autoplay.stop();

        resumeTimeout = setTimeout(() => {
          swiper.autoplay.start();
        }, delayTouchDevices);
      }
    }
  });
}
